import useViewer from 'hooks/useViewer';
import { classifyFlowAccess } from 'utils/client/flow/classifyFlowAccess';
import type { FlowAccess } from 'components/MarketDataStatus';

/**
 * The viewer's options-flow entitlement, in one place so every surface agrees.
 *
 * A thin hook over `classifyFlowAccess`, which is the app's single source of truth for who receives
 * the live tape — the same classifier `useTickerFlowData` uses to pick its query, so the status dot
 * and the fetch path can never disagree about a viewer's plan. Callers must render nothing about a
 * plan while this is `unknown`.
 */
export const useFlowAccess = (): FlowAccess => classifyFlowAccess(useViewer());

export default useFlowAccess;
